import { format } from "date-fns";

/**
 * Calendar-day helpers for inclusive date-range filters.
 */

/** The local calendar day of a picked range bound */
export const toCalendarDay = (date: Date | undefined): string | undefined =>
  date ? format(date, "yyyy-MM-dd") : undefined;

/** The local calendar day of a value returned by the API. */
export const apiValueToCalendarDay = (
  value: string | Date | null | undefined,
): string | null => {
  if (!value) return null;
  const parsed = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return format(parsed, "yyyy-MM-dd");
};

/**
 * Whether a document date falls inside an inclusive range
 */
export const isWithinDayRange = (
  value: string | Date | null | undefined,
  range: { from: Date | undefined; to: Date | undefined },
): boolean => {
  if (!range.from && !range.to) return true;

  const day = apiValueToCalendarDay(value);
  if (!day) return false;

  const from = toCalendarDay(range.from);
  const to = toCalendarDay(range.to);

  if (from && day < from) return false;
  if (to && day > to) return false;
  return true;
};
